import axiosClient from '@/config/api/axios.js'
import { CHAT_THREADS } from '@/config/api/endpoints'

export function isThreadsApiAvailable() {
  return true
}

export async function fetchThreads({ signal } = {}) {
  const { data } = await axiosClient.get(CHAT_THREADS, { signal })
  return Array.isArray(data) ? data : []
}

export async function createThread({ id, title, signal } = {}) {
  const { data } = await axiosClient.post(CHAT_THREADS, { id, title }, { signal })
  return data
}

export async function fetchThreadDetail(threadId, { signal } = {}) {
  const { data } = await axiosClient.get(`${CHAT_THREADS}/${encodeURIComponent(threadId)}`, { signal })
  return data
}

export async function fetchThreadMessages(threadId, { signal } = {}) {
  const { data } = await axiosClient.get(`${CHAT_THREADS}/${encodeURIComponent(threadId)}/messages`, {
    signal,
  })
  return Array.isArray(data) ? data : []
}

export async function fetchThreadRuns(threadId, { activeOnly = false, signal } = {}) {
  const { data } = await axiosClient.get(`${CHAT_THREADS}/${encodeURIComponent(threadId)}/runs`, {
    params: activeOnly ? { active_only: true } : undefined,
    signal,
  })
  return Array.isArray(data) ? data : []
}

export async function updateThreadTitle(threadId, title) {
  const { data } = await axiosClient.patch(`${CHAT_THREADS}/${encodeURIComponent(threadId)}`, { title })
  return data
}

export async function deleteThread(threadId) {
  const { data } = await axiosClient.delete(`${CHAT_THREADS}/${encodeURIComponent(threadId)}`)
  return data
}
